import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import PortfolioContainer from "./components/PortfolioContainer";
import { ThemeContext } from "./context/ThemeContext";
import { useContext } from "react";


const App = () => {
    const theme = useContext(ThemeContext);
    const darkMode = theme.state.darkMode;

    return (
        <div style={{
            backgroundColor: darkMode ? "#333333" : "",
            color: darkMode ? "#f5f5f5" : "inherit",

        }}>
            <PortfolioContainer />
        </div>

    );
};


export default App;
